module.exports = __webpack_public_path__ + "img/engravingSymbol@2x.501076f.jpg";